import React from 'react';
import MailTemplateList from "@pages/email/template/list/MailTemplateList";
import {MailTempType} from "@pages/email/common/Constant";

const SignatureMailTemplateList = () => {
    return (
        <div>
            <MailTemplateList templateType={MailTempType.SIGNATURE}/>
        </div>
    );
};

export default SignatureMailTemplateList;
